(function () {
  'use strict';

  var root = document.getElementById('emotion-countdown-root');
  if (!root) return;

  var STORAGE_PREFIX = 'emotion-countdown-v1:';
  var URGENT_THRESHOLD_MS = 5 * 60 * 1000;
  var tickHandle = null;
  var mqMobile =
    typeof window.matchMedia !== 'undefined' &&
    window.matchMedia('(max-width: 749px)');

  function readConfig(el) {
    return {
      shopKey: el.dataset.shopKey || 'default',
      campaign: el.dataset.campaign || 'default',
      durationMinutes: parseInt(String(el.dataset.durationMinutes || '30'), 10) || 30,
      sublineMode: el.dataset.sublineMode === 'static' ? 'static' : 'dynamic',
      sublineStatic: el.dataset.sublineStatic || '',
      dynamicPrefix: el.dataset.dynamicPrefix || '',
      hourLong: el.dataset.hourLong || 'uur',
      minuteLong: el.dataset.minuteLong || 'minuten',
    };
  }

  function storageKey(config) {
    return STORAGE_PREFIX + config.shopKey + ':' + config.campaign;
  }

  function loadState(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function saveState(key, state) {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch (e) {
      /* quota or private mode */
    }
  }

  function resolveEndTimestamp(config) {
    var key = storageKey(config);
    var existing = loadState(key);
    var campaignMatch = existing && existing.campaign === config.campaign;
    var durationMatch =
      existing &&
      typeof existing.durationMinutes === 'number' &&
      existing.durationMinutes === config.durationMinutes;

    var durMs = config.durationMinutes * 60 * 1000;
    if (durMs <= 0) {
      return null;
    }

    if (!campaignMatch || !existing || typeof existing.endTs !== 'number' || !durationMatch) {
      var endTs = Date.now() + durMs;
      saveState(key, {
        v: 1,
        campaign: config.campaign,
        durationMinutes: config.durationMinutes,
        endTs: endTs,
      });
      return endTs;
    }

    return existing.endTs;
  }

  function formatPad(n) {
    return String(n).padStart(2, '0');
  }

  function updateDisplay(rootEl, ms) {
    if (ms < 0) ms = 0;
    var totalSec = Math.floor(ms / 1000);
    var hours = Math.floor(totalSec / 3600);
    var minutes = Math.floor((totalSec % 3600) / 60);
    var seconds = totalSec % 60;

    var hEl = rootEl.querySelector('[data-unit="hours"]');
    var mEl = rootEl.querySelector('[data-unit="minutes"]');
    var sEl = rootEl.querySelector('[data-unit="seconds"]');
    if (hEl) {
      hEl.textContent =
        hours >= 100 ? String(hours) : formatPad(hours);
    }
    if (mEl) mEl.textContent = formatPad(minutes);
    if (sEl) sEl.textContent = formatPad(seconds);

    var cfg = rootEl._emotionCfg;
    var subEl = rootEl.querySelector('[data-subline]');
    if (subEl && cfg) {
      if (cfg.sublineMode === 'static') {
        subEl.textContent = cfg.sublineStatic;
      } else {
        var hRemain = Math.floor(ms / 3600000);
        var minRemain = Math.floor((ms % 3600000) / 60000);
        var parts = [cfg.dynamicPrefix, hRemain, cfg.hourLong, minRemain, cfg.minuteLong].filter(function (p, i) {
          if (i === 0 && !String(p || '').trim()) return false;
          return true;
        });
        subEl.textContent = parts.join(' ');
      }
    }

    var live = rootEl.querySelector('[data-live-region]');
    if (live) {
      var hr = Math.floor(ms / 3600000);
      var mn = Math.floor((ms % 3600000) / 60000);
      var sc = Math.floor((ms % 60000) / 1000);
      live.textContent =
        hr + ' hours, ' + mn + ' minutes, ' + sc + ' seconds remaining';
    }
  }

  function updatePillDisplay(rootEl, ms) {
    if (ms < 0) ms = 0;
    var timeEl = rootEl.querySelector('[data-pill-time]');
    if (!timeEl) return;
    var totalSec = Math.floor(ms / 1000);
    if (ms < 60000) {
      var mm = Math.floor(totalSec / 60);
      var ss = totalSec % 60;
      timeEl.textContent = formatPad(mm) + ':' + formatPad(ss);
    } else {
      var hours = Math.floor(totalSec / 3600);
      var minutes = Math.floor((totalSec % 3600) / 60);
      timeEl.textContent = formatPad(hours) + ':' + formatPad(minutes);
    }

    var live = rootEl.querySelector('[data-live-region]');
    if (live && (ms < 60000 || ms % 60000 < 1500)) {
      var hr = Math.floor(ms / 3600000);
      var mn = Math.floor((ms % 3600000) / 60000);
      live.textContent = hr + ' hours, ' + mn + ' minutes remaining';
    }
  }

  function maybeApplyUrgent(rootEl, ms) {
    if (rootEl._urgentApplied) return;
    if (ms > URGENT_THRESHOLD_MS) return;
    var pill = rootEl.querySelector('[data-emotion-countdown-pill]');
    if (!pill) return;
    rootEl._urgentApplied = true;
    pill.classList.add('emotion-countdown__pill--urgent');
  }

  function stop() {
    if (tickHandle != null) {
      clearTimeout(tickHandle);
      tickHandle = null;
    }
  }

  function hide(rootEl) {
    rootEl.setAttribute('hidden', '');
    rootEl.setAttribute('aria-hidden', 'true');
    stop();
  }

  function show(rootEl) {
    rootEl.removeAttribute('hidden');
    rootEl.setAttribute('aria-hidden', 'false');
  }

  function scheduleNext(rootEl, remain, isMobile) {
    var nextDelay;
    if (isMobile && remain > 60000) {
      nextDelay = remain % 60000;
      if (nextDelay < 200) nextDelay = 60000;
    } else {
      nextDelay = 1000 - (Date.now() % 1000);
      if (nextDelay < 100) nextDelay = 1000;
    }
    tickHandle = window.setTimeout(function () {
      tickOnce(rootEl);
    }, nextDelay);
  }

  function tickOnce(rootEl) {
    var endTs = rootEl._endTs;
    if (typeof endTs !== 'number') return;
    var remain = endTs - Date.now();
    var isMobile = !!(mqMobile && mqMobile.matches);
    if (remain <= 0) {
      if (isMobile) updatePillDisplay(rootEl, 0);
      else updateDisplay(rootEl, 0);
      hide(rootEl);
      return;
    }
    if (isMobile) {
      updatePillDisplay(rootEl, remain);
      maybeApplyUrgent(rootEl, remain);
    } else {
      updateDisplay(rootEl, remain);
    }
    scheduleNext(rootEl, remain, isMobile);
  }

  function init() {
    var cfg = readConfig(root);
    root._emotionCfg = cfg;
    var endTs = resolveEndTimestamp(cfg);
    if (endTs == null) {
      hide(root);
      return;
    }
    root._endTs = endTs;

    show(root);
    tickOnce(root);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      stop();
      tickOnce(root);
    });

    if (mqMobile && typeof mqMobile.addEventListener === 'function') {
      mqMobile.addEventListener('change', function () {
        root._urgentApplied = false;
        var pill = root.querySelector('[data-emotion-countdown-pill]');
        if (pill) pill.classList.remove('emotion-countdown__pill--urgent');
        stop();
        tickOnce(root);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
